import { useMemo } from 'react'

import { Loader } from '@mantine/core'
import useGetTotalClaimed from 'hooks/useGetTotalClaimed.ts'
import useGetTotalLoaded from 'hooks/useGetTotalLoaded.ts'
import useGetTotalVestedSupply from 'hooks/useGetTotalVestedSupply.ts'

import { formatBigNumber } from 'utils/formatBigNumber.ts'

import s from './s.module.scss'

type BodyBlock = {
  footer?: string
  loading?: boolean
  title: string
  value: bigint
}

const LSD_DECIMALS = 100_000_000n

const ClaimProgressWidget = () => {
  const { isLoading: loadingTotalClaimed, totalClaimed } = useGetTotalClaimed()
  const { isLoading: loadingTotalLoaded, totalLoaded } = useGetTotalLoaded()
  const { isLoading: loadingTotalVestedSupply, totalVested } = useGetTotalVestedSupply()

  let unclaimed = 0n

  if (totalLoaded && totalClaimed) unclaimed = BigInt(totalLoaded) - BigInt(totalClaimed)

  const userStatsBlocks: BodyBlock[] = useMemo(
    () => [
      {
        loading: loadingTotalVestedSupply,
        title: 'Total airdrop allocation', // allocation
        value: BigInt(totalVested) / LSD_DECIMALS,
      },
      {
        loading: loadingTotalClaimed,
        title: 'Claimed',
        value: BigInt(totalClaimed) / LSD_DECIMALS, // decimals = 8
      },
      // {
      //   value: String(1.1e9), // 1.1B
      //   title: 'Forfeit',
      // },
      {
        loading: loadingTotalLoaded,
        title: 'Unclaimed',
        value: unclaimed > 0n ? unclaimed / LSD_DECIMALS : 0n,
      },
      {
        loading: loadingTotalVestedSupply || loadingTotalClaimed || loadingTotalLoaded,
        title: 'Vesting',
        value: (BigInt(totalVested) - BigInt(totalClaimed) - BigInt(unclaimed)) / LSD_DECIMALS,
      },
    ],
    [
      loadingTotalClaimed,
      loadingTotalLoaded,
      loadingTotalVestedSupply,
      totalClaimed,
      totalVested,
      totalLoaded,
      unclaimed,
    ],
  )

  return (
    <div className={s.statsWrapper}>
      {userStatsBlocks.map(({ footer, loading, title, value }) => (
        <div className={s.statsBlock} key={title}>
          <p className={s.title}>{title}</p>
          {loading && <Loader />}
          {!loading && (
            <>
              <p className={s.stats} title={String(value)}>
                {value ? formatBigNumber(value) : '\u2013'}
              </p>
              {footer && <p className={s.footer}>{footer}</p>}
            </>
          )}
        </div>
      ))}
    </div>
  )
}

export default ClaimProgressWidget
